function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const AccountsIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5v-.2c1.4-.6 2.5-2.3 2.5-4.3 0-2.5-1.6-4.5-3.5-4.5s-3.5 2-3.5 4.5c0 2 1.1 3.8 2.5 4.3v.2c-3.4.1-6 1-6 2v2h14v-2c0-1-2.6-1.8-6-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10.5c1.1-.4 2-1.8 2-3.5 0-1.9-1.1-3.5-2.5-3.5S15 5.1 15 7c0 1.7.9 3.1 2 3.4v.1c-.5 0-1 .1-1.4.1-.1 1.1-.4 2.1-1 2.9H22V12c0-.8-1.8-1.4-4-1.5zM6.4 10.6c-.4 0-.9-.1-1.4-.1v-.1c1.1-.3 2-1.7 2-3.4 0-1.9-1.1-3.5-2.5-3.5S2 5.1 2 7c0 1.7.9 3.1 2 3.4v.1c-2.2.1-4 .7-4 1.5v1.5h7.4c-.6-.8-.9-1.8-1-2.9z"
  }));
};
export default AccountsIcon;